import { configureStore } from '@reduxjs/toolkit'
import authReducer from './auth/authSlice'
import twoFactorAuthReducer from './auth/twoFactorAuthSlice'
import passwordReducer from './auth/passwordSlice';
import webhookReducer from './webhooks/webhookSlice';
import orderReducer from './orders/orderSlice';
import documentReducer from './documents/documentSlice';
import systemHealthReducer from './systemHealth/systemHealth';
import slaReducer from './client/slaSlice';
import ebillSettingsReducer from './client/ebillSettingsSlice';
import orderStatusesReducer from './client/orderStatusesSlice';
import documentStatusesReducer from './client/documentStatusesSlice';
import reportingReducer from './reporting/reportingSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        twoFactorAuth: twoFactorAuthReducer,
        passwordSettings: passwordReducer,
        webhook: webhookReducer,
        order: orderReducer,
        document: documentReducer,
        systemHealth: systemHealthReducer,
        sla: slaReducer,
        ebillSettings: ebillSettingsReducer,
        orderStatuses: orderStatusesReducer,
        documentStatuses: documentStatusesReducer,
        reporting: reportingReducer,
    }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store
